import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  FDBodyText, FDEmptyState, FDStack, FDBox,
} from '@facet-wealth/design';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ChangesAccordionGroup
  from 'Views/Page/Content/Templates/FacetPlanClickToSync/ReviewChanges/ChangesAccordionGroup';
import Box from '../../../../../../Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100dvh',
  },
  navigation: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    flexDirection: 'column',
  },
});

const FacetPlanClickToSyncReviewChangesTemplate = ({
  classes,
  resource,
}) => {
  const [loading, setLoading] = useState(false);
  const { loadPageContentLink, isPageContentLoading } = usePageContentContext();

  const handleOnNext = resource.withRelationship(
    fr.relationships.facetPlanView.name,
    (rel) => async () => {
      setLoading(true);
      try {
        await loadPageContentLink(rel.link('related'));
      } catch (e) {
        setLoading(false);
      }
      setLoading(false);
    },
    () => null,
  );

  return (
    <Box className={classes.root}>
      <FDStack alignItems="center" direction="column" flexGrow={1}>
        <PageHeader title={resource.attr('title')} />
        {resource.attr('subtitle') !== undefined && <FDBodyText value={resource.attr('subtitle')} />}
        <FDBox paddingY={2}>
          { resource.attr('hasChangesToReview') === 'true' ? (
            <FDStack direction="column" spacing={2}>
              <ChangesAccordionGroup title="Account Changes" collection={resource.attr('facetPlanVirtualAccountLogs')} />
              <ChangesAccordionGroup title="Real Asset Changes" collection={resource.attr('facetPlanRealAssetLogs')} />
              <ChangesAccordionGroup title="Income Changes" collection={resource.attr('facetPlanIncomeLogs')} />
              <ChangesAccordionGroup title="Expense Changes" collection={resource.attr('facetPlanExpenseLogs')} />
              <ChangesAccordionGroup title="Assumption Changes" collection={resource.attr('assumptionLogs')} />
            </FDStack>
          ) : (
            <FDEmptyState
              description="No Changes Were Made"
              icon="check"
              title="Scenario Was Already Up-To-Date"
            />
          )}
        </FDBox>
      </FDStack>
      <div className={classes.navigation}>
        <StepNavigator
          onNext={handleOnNext}
          isLoading={isPageContentLoading || loading}
        >
          {resource.attr('primaryActionLabel')}
        </StepNavigator>
      </div>
    </Box>
  );
};

FacetPlanClickToSyncReviewChangesTemplate.defaultProps = {};

FacetPlanClickToSyncReviewChangesTemplate.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(FacetPlanClickToSyncReviewChangesTemplate);
